import { render, staticRenderFns } from "./member-profile-card.vue?vue&type=template&id=073908cc&scoped=true&"
import script from "./member-profile-card.vue?vue&type=script&lang=js&"
export * from "./member-profile-card.vue?vue&type=script&lang=js&"
import style0 from "./member-profile-card.vue?vue&type=style&index=0&id=073908cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073908cc",
  null
  
)

export default component.exports